export interface ErrorIconProps {
  color?: string;
  width?: string;
  height?: string;
}

export function ErrorIcon({
  color = '#DA344D',
  width = '15',
  height = '15',
  ...rest
}: ErrorIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15 15'
      fill='none'
      {...rest}
    >
      <path
        d='M7.5 0.999999C3.91015 0.999999 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 0.999999Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.5 4.9L7.5 7.5'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.5 10.1001L7.493 10.1001'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
